// ── Regulatory Mode ──────
export var RegulatoryMode;
(function (RegulatoryMode) {
    RegulatoryMode["EU"] = "EU";
    RegulatoryMode["US"] = "US";
    RegulatoryMode["EU_NON_PREPACKED"] = "EU_NON_PREPACKED";
})(RegulatoryMode || (RegulatoryMode = {}));
export function detectDefaultMode() {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (tz && tz.startsWith('America/')) {
            return RegulatoryMode.US;
        }
    }
    catch { }
    return RegulatoryMode.EU;
}
// ── EU 14 Allergens (Annex II, Regulation (EU) No 1169/2011) ──────
export var EUAllergen;
(function (EUAllergen) {
    EUAllergen["CerealsContainingGluten"] = "cereals_containing_gluten";
    EUAllergen["Crustaceans"] = "crustaceans";
    EUAllergen["Eggs"] = "eggs";
    EUAllergen["Fish"] = "fish";
    EUAllergen["Peanuts"] = "peanuts";
    EUAllergen["Soybeans"] = "soybeans";
    EUAllergen["Milk"] = "milk";
    EUAllergen["TreeNuts"] = "tree_nuts";
    EUAllergen["Celery"] = "celery";
    EUAllergen["Mustard"] = "mustard";
    EUAllergen["Sesame"] = "sesame";
    EUAllergen["Sulphites"] = "sulphur_dioxide_sulphites";
    EUAllergen["Lupin"] = "lupin";
    EUAllergen["Molluscs"] = "molluscs";
})(EUAllergen || (EUAllergen = {}));
// ── US 9 Allergens (FALCPA + FASTER Act) ──────
export var USAllergen;
(function (USAllergen) {
    USAllergen["Milk"] = "milk";
    USAllergen["Eggs"] = "eggs";
    USAllergen["Fish"] = "fish";
    USAllergen["CrustaceanShellfish"] = "crustacean_shellfish";
    USAllergen["TreeNuts"] = "tree_nuts";
    USAllergen["Peanuts"] = "peanuts";
    USAllergen["Wheat"] = "wheat";
    USAllergen["Soybeans"] = "soybeans";
    USAllergen["Sesame"] = "sesame";
})(USAllergen || (USAllergen = {}));
// ── Display Labels ──────
const categoryLabels = {
    cereals_containing_gluten: 'Gluten',
    crustaceans: 'Crustaceans',
    crustacean_shellfish: 'Crustacean Shellfish',
    eggs: 'Eggs',
    fish: 'Fish',
    peanuts: 'Peanuts',
    soybeans: 'Soy',
    milk: 'Milk',
    tree_nuts: 'Tree Nuts',
    celery: 'Celery',
    mustard: 'Mustard',
    sesame: 'Sesame',
    sulphur_dioxide_sulphites: 'Sulphites',
    lupin: 'Lupin',
    molluscs: 'Molluscs',
    wheat: 'Wheat',
    unknown: 'Ambiguous ingredients',
};
export function categoryLabel(category) {
    return categoryLabels[category] ?? category
        .split('_')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
}
//# sourceMappingURL=allergens.js.map